export default __webpack_public_path__ + "static/media/login-bg-mobile.eeb45cdb.png";